import React from 'react';
import { connect } from 'react-redux';
import { prop } from 'ramda';
import ContainerDimensions from 'react-container-dimensions';
import { Flex, Box } from 'grid-styled';
import { createSelector } from 'reselect';
import { RaisedButton } from 'material-ui';

import { VisType, Compare } from '../constants';
import { isSingleInterval } from '../selectors/intervals';
import { getCompare, getCompChartType } from '../selectors/options';
import { setCompChartType } from '../actions/options';
import { BrowserLocation } from '../models';

import { NoChart } from './NoContent';
// ChartAndLegend
import LineChart from './LineChart';
// DeltaBarChart
import DeltaBarChart from './DeltaBarChart/DeltaBarChartContainer';
// ChartAndLegend
import ComparisonChart from './ComparisonChartContainer';
// ChartAndLegend
import RecurringChart from './RecurringChartContainer';
// ChartAndLegend
import SingleIntervalChart from './SingleIntervalChart';

export const getChartType = createSelector(
  getCompare,
  getCompChartType,
  isSingleInterval,
  (compare, compChartType, singleInterval) =>
    ({
      [Compare.PERIOD]: compChartType,
      [Compare.YEAR]: compChartType,
      [Compare.CUSTOM]: compChartType,
      [Compare.NONE]: singleInterval ? VisType.SINGLE : VisType.LINE,
      [Compare.RECURRING]: VisType.RECURRING,
    }[compare]),
);

const maxWidth = 1200;

const OuterContainer = Flex.extend`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  flex-direction: column;
`;

// XXX: can't just use 100% height or something like it
// because of different rendering in Safari
// https://stackoverflow.com/questions/33636796/chrome-safari-not-filling-100-height-of-flex-parent
const Container = Box.extend`
  height: ${prop('height')}px;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;

const InnerContainer = Box.extend`
  position: relative;
  height: 100%;
  width: 100%;
  max-width: ${maxWidth}px;
  margin: 45px auto 0;
`;

const chartComponents = {
  [VisType.LINE]: LineChart,
  [VisType.DIFFERENCE]: DeltaBarChart,
  [VisType.COMPARISON]: ComparisonChart,
  [VisType.RECURRING]: RecurringChart,
  [VisType.SINGLE]: SingleIntervalChart,
};

const ChartPage = ({ chartType, setCompChartType }) => {
  const showSwitch =
    chartType === VisType.DIFFERENCE || chartType === VisType.COMPARISON;

  return (
    <OuterContainer>
      {showSwitch ? (
        <Box px={2} py={16}>
          {/* Margin tweaks to align with the absolute positioned View Selector
            See Toolbar.scss for @media rules */}
          <RaisedButton
            className="compChartButton"
            style={{
              marginLeft: '392px',
              marginTop: '-10px',
            }}
            buttonStyle={{
              height: '42px',
              lineHeight: '42px',
            }}
            overlayStyle={{
              height: '42px',
              lineHeight: '42px',
            }}
            labelStyle={{
              textTransform: 'none',
            }}
            primary
            onClick={() =>
              setCompChartType(
                chartType === VisType.DIFFERENCE
                  ? VisType.COMPARISON
                  : VisType.DIFFERENCE,
              )
            }
            label={
              chartType === VisType.DIFFERENCE
                ? 'Go to comparison chart'
                : 'Go to difference chart'
            }
          />
        </Box>
      ) : null}
      <Box style={{ minHeight: 0, flex: '1 1 auto' }}>
        <ContainerDimensions>
          {({ width, height }) => {
            const Chart = chartComponents[chartType];

            return (
              <Container height={height}>
                <InnerContainer>
                  {Chart ? (
                    <Chart width={Math.min(width, maxWidth)} height={height} />
                  ) : (
                    <NoChart />
                  )}
                </InnerContainer>
              </Container>
            );
          }}
        </ContainerDimensions>
      </Box>
    </OuterContainer>
  );
};

ChartPage.propTypes = {
  location: BrowserLocation.isRequired,
};

export default connect(
  state => ({
    chartType: getChartType(state),
  }),
  {
    setCompChartType,
  },
)(ChartPage);



// WEBPACK FOOTER //
// ./src/components/ChartPage.jsx